import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BroadcastCard from 'components/cards/BroadcastCard';
import Filters from 'components/Catalog/components/Filters';
import CatalogTemplate from 'components/Catalog';

import CommonPropTypes from 'utils/propTypes/common';

const Catalog = ({
	title,
	subtitle,
	total,
	limit,
	urlParams,
	movies,
	filtersLoaded,
	filters,
	onFilterReset,
	onFilterChange
}) => {
	const { page, sort, limit: limitParam, ...filterValues } = urlParams;

	const gridItems = useMemo(
		() =>
			_(movies).map((movie) => (
				<BroadcastCard key={movie._id} data={movie} size="elastic" />
			)),
		[movies]
	);

	const filtersNode = filtersLoaded && (
		<Filters
			items={filters}
			onReset={onFilterReset}
			onChange={onFilterChange}
			values={filterValues}
		/>
	);

	return (
		<CatalogTemplate
			title={title}
			subtitle={subtitle}
			handleSort={onFilterChange}
			total={total}
			theme="horizontalCards"
			filters={filtersNode}
			urlParams={urlParams}
			emptyMessage="К сожалению, по вашему запросу трансляций не найдено."
			gridItems={gridItems}
			limit={limit}
		/>
	);
};

Catalog.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	total: PropTypes.number.isRequired,
	limit: PropTypes.number.isRequired,
	urlParams: PropTypes.object,
	movies: CommonPropTypes.entities,
	filtersLoaded: PropTypes.bool,
	filters: PropTypes.array,
	onFilterReset: PropTypes.func,
	onFilterChange: PropTypes.func
};

Catalog.defaultProps = {
	title: 'Архив записей трансляций',
	urlParams: {},
	movies: [],
	filters: [],
	filtersLoaded: true
};

export default Catalog;
